import React, { Component } from 'react';
import { connect } from 'react-redux';
import { LogIn } from './subcomponents/LogIn'
import { SlPageTitle } from './editors';
import { userActions } from '../_actions';


class LogInMain extends Component {
    static displayName = LogInMain.name;
    componentDidMount(){
        const {loginHash,handleLoginWithHash} = this.props
        if(loginHash){
            handleLoginWithHash(loginHash)
        }
    }
    render() {
        return (
            <div>
                <SlPageTitle pageName="WelcomeToSunLoan"/>
                <LogIn />
            </div>
        );
    }
}
function mapStateToProps(state,props) {    
    const  loginHash  = props.match && props.match.params ? props.match.params.hash : null; 
      return {
        loginHash
      };
  }
  
  const mapDispatchToProps = (dispatch) => {
    return {     
      handleLoginWithHash :  (loginHash) => dispatch(userActions.handleLoginWithHash(loginHash))
    };
  };
  
  const connectedLogInMain = connect(
    mapStateToProps,
    mapDispatchToProps
  )(LogInMain);
  export { connectedLogInMain as LogInMain };
  
